module.exports = __webpack_public_path__ + "static/media/CTKM15.08c5166b.svg";